import { EstateAccount } from '/@/modules/estateaccount/models/EstateAccount';

export class EstateAccountRow extends EstateAccount {
  //
}
